export default "__VITE_ASSET__012ab148__"